/**
 * @returns уникальное значение (ID) для установки в React-элемент (атрибут key),
 * может использоваться в качестве уникального свойства в массиве. Пример: 'a1b2c'.
 *
 * Генерирует его с учетом следующих пропорций:
 * - 1-й символ - 26 комбинаций [a-z];
 * - 2-й символ - 10 комбинаций [0-9];
 * - 3-й символ - 26 комбинаций [a-z];
 * - 4-й символ - 10 комбинаций [0-9];
 * - 5-й символ - 26 комбинаций [a-z].
 *
 * Вероятность встречаемости дублирующегося значения p = 1 / 1 757 600.
 *
 * Может использоваться в качестве альтернативы uuid, уменьшающей размер сборки.
 * Рекомендуется использовать аккуратно в случаях, когда серверный метод ожидает ID на входе,
 * т.к. в PostgreSQL (применяемом в проекте), для значений отдельных колонок может быть
 * предусмотрен специальный тип uuid. Данный тип результат утилиты пропускать не будет.
 */

export const createId: () => string = () => {
  const DIGITS = '0123456789';
  const ENGLISH_ALPHABET = 'abcdefghijklmnopqrstuvwxyz';
  const MAX_ID_LENGTH = 5;

  let result = '';

  for (let i = 0; i < MAX_ID_LENGTH; i++) {
    if (i % 2 === 0) {
      result += ENGLISH_ALPHABET.charAt(
        Math.floor(Math.random() * ENGLISH_ALPHABET.length)
      );
    } else {
      result += DIGITS.charAt(Math.floor(Math.random() * DIGITS.length));
    }
  }

  return result;
};
